(function($){


/* from gallery.js */
var filters = {
	await: function () {
		$('.gallery-type-filter.dropdown .option').on('click', function (e) {
			var type = $(e.currentTarget).attr('data-value');
			var photographer = $('.gallery-photographer-filter.dropdown .option.selected').attr('data-value');
			var product = $('.gallery-product-filter.dropdown .option.selected').attr('data-value');

			var total_per_page = parseInt($('.gallery-more').attr('data-total-per-page'));
			var found_posts = parseInt($('.gallery-more').attr('data-found-posts'));
			var total_on_page = total_per_page > found_posts ? total_per_page : found_posts;

			this.filter_ajax_filtering(type,photographer,product,total_per_page, total_on_page);
		}.bind(this));

		$('.gallery-photographer-filter.dropdown .option').on('click', function (e) {
			var type = $('.gallery-type-filter.dropdown .option.selected').attr('data-value');
			var photographer = $(e.currentTarget).attr('data-value');
			var product = $('.gallery-product-filter.dropdown .option.selected').attr('data-value');

			var total_per_page = parseInt($('.gallery-more').attr('data-total-per-page'));
			var found_posts = parseInt($('.gallery-more').attr('data-found-posts'));
			var total_on_page = total_per_page > found_posts ? total_per_page : found_posts;

			this.filter_ajax_filtering(type,photographer,product,total_per_page, total_on_page);
		}.bind(this));

		$('.gallery-product-filter.dropdown .option').on('click', function (e) {
			var type = $('.gallery-type-filter.dropdown .option.selected').attr('data-value');
			var photographer = $('.gallery-photographer-filter.dropdown .option.selected').attr('data-value');
			var product = $(e.currentTarget).attr('data-value');

			var total_per_page = parseInt($('.gallery-more').attr('data-total-per-page'));
			var found_posts = parseInt($('.gallery-more').attr('data-found-posts'));
			var total_on_page = total_per_page > found_posts ? total_per_page : found_posts;

			this.filter_ajax_filtering(type,photographer,product,total_per_page, total_on_page);
		}.bind(this));

		/*$(window).scroll(function (){

			var position = $(window).scrollTop();
			var bottom = $(document).height() - ($('.newsletter-section').outerHeight(true) + $('.footer-section').outerHeight(true) ) - $(window).height();

			console.log(bottom);

			if ( position >= bottom ) {

				var type = $('.gallery-type-filter.dropdown .option.selected').attr('data-value');
				var photographer = $('.gallery-photographer-filter.dropdown .option.selected').attr('data-value');
				var product = $('.gallery-product-filter.dropdown .option.selected').attr('data-value');

				var total_per_page = parseInt($('.gallery-more').attr('data-total-per-page'));
				var found_posts = parseInt($('.gallery-more').attr('data-found-posts'));

				var total_on_page = total_per_page > found_posts ? total_per_page : found_posts;
				total_on_page += 4;

				this.filter_ajax_filtering(type,photographer,product,total_per_page, total_on_page);
			}
		}.bind(this));*/

		$('#wng-gallery .load-more').on('click', function (e) {
            e.preventDefault();
            var type = $('.gallery-type-filter.dropdown .option.selected').attr('data-value');
            var photographer = $('.gallery-photographer-filter.dropdown .option.selected').attr('data-value');
            var product = $('.gallery-product-filter.dropdown .option.selected').attr('data-value');

            var total_per_page = parseInt($('.gallery-more').attr('data-total-per-page'));
            var found_posts = parseInt($('.gallery-more').attr('data-found-posts'));

            var total_on_page = total_per_page > found_posts ? total_per_page : found_posts;
            total_on_page += 12;

            this.filter_ajax_filtering(type,photographer,product,total_per_page, total_on_page);
        }.bind(this));
	},
	test: function(){
		console.log($('.store-tags-input').val());
	},
	filter_ajax_filtering: function (type, photographer, product,total_per_page, total_on_page) {

		//console.log({type,photographer,product,total_on_page});

		var $result =  $.ajax({
			url: ajax.url,
			method:'POST',
			async: false,
			cache: false,
			timeout: 30000,
			data: {
				action : 'filter_galleries',
				type: type,
				photographer: photographer,
				product: product,
				total: total_on_page,
				total_per_page: total_per_page,
			},
			beforeSend:function(){
				$('#wng-gallery .spinner').addClass('active');
			},
			error: function (){
				return true;
			},
			success: function(response) {

				$('.gallery-more').attr('data-found-posts', response.found_posts);
				$('.gallery-more').attr('data-total-posts', response.total_posts);

				var total_posts = $('.gallery-more').attr('data-total-posts');

				if ( response.found_posts >= response.total_posts ){
					$('.gallery-more').addClass('inactive');
				} else {
					$('.gallery-more').removeClass('inactive');
				}

				$('#wng-gallery .spinner').removeClass('active');
				$('.all-galleries').html(response.html);

				return true;
			},
		});

		return $result;
	}
};
/* from gallery.js */

/* from gallery.js */
if ( $('#wng-gallery').length ){
	$(document).ready(function (e) {
		filters.await();
	});
}
/* from gallery.js */

})(jQuery);